export { CourseStateType } from './course-state.enum'
export * from './course-lms-profile-type.enum'
export * from './enrol-state.enum'
export * from './enrol-evaluation-state.enum'
export { AssignedLessonStateEnum } from './assigned-lesson-state.enum'
export { QuestionTypes } from './questionTypes.enum'
export { BlockTypes } from './block-type.enum'
export { MonitoringStatus } from './monitoring-status.enum'
export { ImgStatusEnum } from './uploadImg-status.enum'
export * from './courseNotifications'
export * from './times.enum'
export * from './emailTypes.enum'
export * from './course-type.enum'
export * from './synchronousCourseTypes.enum'
export * from './amplitude.enum'
export * from './multimediaContentType.enum'

export enum TypesRequests {
  'applications' = 'applications',
}

export enum CourseTypes {
  LMS = 'LMS',
  DNC = 'DNC',
}

export enum GrammaticalGender {
  M = 'male',
  F = 'female',
}
